<template>

		<v-row>
			<v-col cols="12" md="12" > 
					<v-card :elevation="0" color="surface">
						<v-card-title class="mb-10 text-center wbreak text-h4 text-wrap lh-base font-weight-bold on-surface d-flex justify-center">
						Potential Tax Bill Calculator
						</v-card-title>
						<v-card-text :class="display.smAndUp.value ? 'pa-4' : 'pa-0'">
							<v-window v-model="step" :touch="false" class="accent">
										<v-window-item class="pa-0" :value="1">
												<v-form ref="form1" v-model="step1Valid">
													<v-row>
														<v-col class="pb-0" cols="12">
															<div class="d-flex flex-column">
																<label class="text-on-surface text-h6">{{ labelAge }}</label>
																<CurrencyInput
																	ref="formAge"
																	class="
																		flex-grow-1
																		on-white
																	"
																	color="black"
																	variant="outlined"
																	:rules="ageRules"
																	v-model="age"
																	v-bind:placeholder="placeholderAge"
																	v-bind:readonly="readonly"
																	v-bind:disabled="disabled"
																	v-bind:clearable="clearable"
																	v-bind:options="optionsAge"
																	v-bind:properties="propertiesAge"
																/>
															</div>
														</v-col>
														<v-col class="pb-0" cols="12">
															<div class="d-flex flex-column">
																<label class="text-on-surface text-h6">{{ label }}</label>
																<CurrencyInput
																class="
																	flex-grow-1
																	on-white
																"
																required
																variant="outlined"
																prefix="$"
																:thousand-separator="true"
																v-model="ira_value"
																v-bind:placeholder="placeholder"
																v-bind:options="options"
																v-bind:properties="properties"
																:rules="ira_valueRules"
																
																/>
															</div>
														</v-col>
														<v-col cols="12">
															<label class="text-on-surface body-1">{{ labelTaxRate }}</label>
															<v-slider 
																class="tax-rate-slider mt-13 mb-5 pl-4 pr-4"
																:readonly= useTaxRateDefault
																v-model="tax_rate"
																color="primary"
																dense
																max="40" 
																min="15"
																step="5"
																thumb-label="always"
																thumb-size="15"
																show-ticks="always"
																tick-size="6"
																track-color="black"
																track-size="1"
																track-fill-color="primary"
																:ticks="{ 15: '15', 20: '20', 25: '25', 30: '30', 35: '35', 40: '40' }"
															>
																<template v-slot:thumb-label="{ modelValue }">
																	<span class="text-on-primary slider-pin-label__text">{{ modelValue }}%</span>
																</template>
															</v-slider>
															<v-checkbox
																color="primary"
																class="mt-n3 mb-1"
																@change="taxRateToDefault"
																v-model="useTaxRateDefault"
																label=" Don't Know? Use the default tax rate (25%)"
															></v-checkbox>
															
														</v-col>

														<v-col>
																<v-btn size="x-large" :disabled="!step1Valid" color="primary" active-color="primary" base-color="primary"  class="multi-line btn-lowerCase" rounded="pill" block @click="goToStep2">Continue to final Step</v-btn>
														</v-col>
													</v-row>
												</v-form>
											</v-window-item>
									
											<v-window-item class="pa-0" :value="2">
												<v-form ref="form2" v-model="step2Valid">
													<v-row no-gutters class="d-flex flex-row align-center ga-3">
														
														<v-col class="text-on-surface" cols="12">
															<h2>Your analysis is ready!</h2>
															<p>Complete the details below for delivery.</p>											
														</v-col>
														
														<v-col class="pb-0" cols="12" >
															<label class="text-on-surface text-h6">First name *</label>
															<v-text-field
																ref="formFirstName"
																v-model="first_name"
																:rules="nameRules"												
																required														
																class="on-white v-input-white"
																	variant="outlined"
															></v-text-field>
														</v-col>
														<v-col class="pb-0" cols="12">
															<label class="text-on-surface text-h6">Last name *</label>
															<v-text-field
																v-model="last_name"
																:rules="nameRules"
																required
																class="on-white v-input-white"
																	variant="outlined"
															></v-text-field>
														</v-col>
														<v-col class="pb-0" cols="12">
															<label class="text-on-surface text-h6">E-mail *</label>
															<v-text-field
																@keydown.space.prevent
																v-model="email"
																:rules="emailRules"
																required
																class="on-white v-input-white"
																	variant="outlined"
															></v-text-field>
														</v-col>
														<v-col cols="12">
															<label class="text-on-surface text-h6">{{ phoneLabel }}</label>
															<v-text-field
																v-model="phone"
																:rules="phoneRules"
																:required="phoneRequired"
																label=""
																class="on-white v-input-white"
																	variant="outlined"
																:hint="phoneHint"
															></v-text-field>
														</v-col>
														<v-col class="pt-3 d-flex align-center ga-2" cols="12">
																<v-btn icon size="large" @click="goToStep1" :disabled="isSubmitting">
																	<v-icon>mdi-chevron-left</v-icon>
																</v-btn>
																<v-btn size="x-large"  :disabled="!step2Valid || isSubmitting" :loading="isSubmitting" color="primary" class="btn-lowerCase multi-line flex-grow-1 text-on-primary" rounded @click="sendProposal">See my Bill</v-btn>
														</v-col>
													</v-row>
													
													
												</v-form>
											</v-window-item>
									</v-window>
									<!-- <v-row class="" >
										<v-form class="w-100" style="width: 100%;">
											
											<v-col>
												<v-slider 
													class="mt-0"                   
													prepend-icon="mdi-brightness-percent"
													append-icon="mdi-percent-outline"
													label="Average Tax Rate"
													:readonly= useTaxRateDefault
													v-model="tax_rate"
													dense 
													max="40" 
													min="15"
													step="5"
													value="25"
													thumb-label="always"
													thumb-size="23"
													ticks
													>
												</v-slider>
												<v-checkbox
													class="mt-n3 mb-1"
													@change="taxRateToDefault"
													v-model="useTaxRateDefault"
													label=" Don't Know? Use the default tax rate (25%)"
												></v-checkbox>
											</v-col>
										</v-form>
									</v-row> -->
									
								</v-card-text>
								<!-- <v-divider></v-divider>
								<v-card-actions> 
									<v-col class="text-center">
										<v-btn
										color="stonewood_primary"
										class="my-1"
										type="submit"
										:disabled="!valid"
										rounded
										large
										>
										See My Bill
										</v-btn>
										</v-col>
								</v-card-actions> -->
					</v-card>
				</v-col>
		</v-row>      
</template>
<script>
import axios from "axios";
import qs from "qs";
import { useDisplay } from 'vuetify'
import CurrencyInput from "@/components/inputs/CurrencyInput.vue";
import { useLeadGeneratorStore } from "@/stores/leadGenerator";

const BRANDING_API_ORIGIN = import.meta.env.VITE_BRANDING_API_ORIGIN || 'https://beta.stonewoodfinancial.com';
const TAX_BURDEN_LEAD_API_URL = `${BRANDING_API_ORIGIN.replace(/\/$/, '')}/scripts/proposals/rmd/tax-burden-lead.php`;

export default {

	components: { CurrencyInput },

	setup() {
		const store = useLeadGeneratorStore();
		const display = useDisplay()
		return { store, display };
	},

  name: "CalculationForm",
  props: {
    formFocus: {
      type: Boolean,
      default: false
    },
	resultsUrl: {
		type: String,
		default: "/analysis"
	}
  },
  data: () => ({

	step: 1,
	step1Valid: false,
	step2Valid: false,
	isSubmitting: false,
	form1: {
	name: '',
	},
	form2: {
	email: '',
	},

    numberRule: v  => {
      if (!v.trim()) return true;
      if (!isNaN(parseFloat(v)) && v >= 20 && v <= 90) return true;
      return 'Age has to be between 20 and 90';
    },
	labelTaxRate: "Average Tax Rate*",
    label: "Current IRA or 401(k) Value*",
    labelAge: "Enter Current Age *",    
    placeholderAge: "00",
    advisorId:"",
    placeholder: "1,000",
    useTaxRateDefault: false,
    readonly: false,
    disabled: false,
    outlined: true,
    clearable: false,
    valueWhenIsEmpty: "",
    options: {
      locale: "en-US",
      suffix: "",
      length: 11,
      precision: 0,
    },
        iraRules: [
      v => !!v || "This field is required"

    ],
    optionsAge: {
      locale: "en-US",
      suffix: "",
      length: 2,
      precision: 0,
    },
    properties: {
      hint: "Enter amount",
      // You can add other v-text-field properties, here.
    },
    propertiesAge: {
      hint: "Enter Current Age or Age of Oldest Spouse",
      // You can add other v-text-field properties, here.
    },
    activePicker: null,
    menu: false,
    valid: false,
    isTaxable: false,
    dob: null,
    first_name: "",
    last_name: "",
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => !/\//.test(v) || 'Invalid name', 

    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) =>
        !v ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,12})+$/.test(v) ||
        "E-mail must be valid",
    ],
    phone: "",
    age: "",
    ageList: [
       1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99,
    ],
    ageRules: [
		v => !!v || "This field is required",
		v => ( v && v >= 20 ) || "Age should be greater than 20",
		v => ( v && v <= 91 ) || "Age should not be above 90",
    ],
    ira_value: "",
    ira_valueRules: [
		v => !!v || "This field is required",
		(v) => !!v || "This amount is required for the calculation",
		(v) => parseFloat(v) > 0 || "Please enter a value greater than 0"
    ],
											tax_rate: 25,
    LiabilityPercentages: ["15%", "20%", "30%"],
    tax_rateRules: [
		(v) => !!v || "This Percentage is required for the calculation",
		v => ( v && v >= 15 ) || "Tax Rate should be greater than 15%",
		v => ( v && v <= 40 ) || "Tax Rate should not be above 40%",
    ],
  }),
  computed: {
	phoneRequired() {
		this.store.ensureCustomizationDefaults();
		return this.store.customization.formOptions.phoneRequired;
	},
	phoneLabel() {
		return `Phone Number${this.phoneRequired ? ' *' : ''}`;
	},
	phoneHint() {
		return this.phoneRequired ? 'Enter your phone number.' : 'Enter your phone number. Optional';
	},
	phoneRules() {
		const rules = [];

		if (this.phoneRequired) {
			rules.push((v) => !!String(v || '').trim() || 'Phone number is required');
		}

		rules.push(
			(v) =>
				!v ||
				/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(v) ||
				'Phone number must be valid'
		);

		return rules;
	},
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
    formFocus: function(){
      this.focunOnForm();
    },
    phoneRequired() {
		this.$nextTick(() => {
			this.$refs.form2?.validate();
		});
    }
  },
  methods: {
    // focunOnForm(){
    //     //this.$refs["formFirstName"].focus();     
    // },
	goToStep2() {
		window.scrollTo(0, 0);
		this.step = 2;

		this.$nextTick(() => {
			const formFirstNameInput = this.$refs.formFirstName.$el.querySelector('input');
			if(formFirstNameInput) {
				formFirstNameInput.focus(); // Focus the input element
			}
		});
	},
	goToStep1()	{
		window.scrollTo(0, 0);
		this.step = 1;
	},
    focunOnForm() {
		this.$nextTick(() => {
		// Find the actual input element inside the custom vuetify-money component
		const ageInput = this.$refs.formAge.$el.querySelector('input');
		if (ageInput) {
			ageInput.focus(); // Focus the input element
		}
		});
	},
    taxRateToDefault(){
		if(this.useTaxRateDefault){
			this.tax_rate = 25;
		}else{
			this.tax_rate = 25;
		}
    },
    sendProposal() {
		this.isSubmitting = true;
		this.advisorId = this.$route.query.u;
		var userDobYear = parseInt(new Date().getFullYear()) - parseInt(this.age);
		var currentDob = userDobYear + "-01-01";
		var data = qs.stringify({
			first_name: this.first_name,
			last_name: this.last_name,
			phone: this.phone,
			email: this.email,
			dob: currentDob,
			ira_value: this.ira_value,
			tax_rate: this.tax_rate,
			isTaxable: false,
			advisorId: this.$route.query.u,
			companyId: this.$route.query.c,
		});
		var config = {
			method: "post",
			url: TAX_BURDEN_LEAD_API_URL,
			headers: {
				"Content-Type": "application/x-www-form-urlencoded",
			},
			data: data,
		};
		var self = this;
		axios(config)
			.then(function (response) {
				self.store.user.taxPaid = response.data.totalTax;   
				self.store.user.totalTaxesConversion = response.data.totalTaxesConversion;    
				self.store.user.age = self.age;
				self.store.user.taxDeferred = self.ira_value;
				self.store.user.taxRate = self.tax_rate;
				self.store.user.first_name = self.first_name;
				self.store.user.last_name = self.last_name;
				self.store.user.email = self.email;
				self.store.user.phone = self.phone;
				self.store.user.advisorId = response.data.advisorId;
				self.store.user.proposalId = response.data.encryptedId;
				// Mark email as not yet sent so Analysis.vue fires it once for this new proposal
				self.store.resetForNewSubmission();
				self.$router.push({ path: self.resultsUrl, query: { ...self.$route.query } });
			})
			.catch(function (error) {
				console.log(error);
				self.isSubmitting = false; // Re-enable button on error
			});
    },
    save(date) {
		this.$refs.menu.save(date);
    },
  },
};
</script>

<style scoped>
.tax-rate-slider :deep(.v-slider-thumb__label) {
	width: 50px;
	min-width: 50px;
	height: 50px;
	padding: 0;
	position: relative;
	border-radius: 999px;
	bottom: calc(var(--v-slider-thumb-size) / 2 + 50px) !important;
	background-color: rgb(var(--v-theme-primary));
}

.tax-rate-slider :deep(.v-slider-thumb__label > .v-slider-thumb__label-wedge) {
	display: none;
}

.tax-rate-slider :deep(.v-slider-thumb__label::after) {
	content: '';
	position: absolute;
	left: 50%;
	bottom: -5px;
	width: 14px;
	height: 14px;
	background-color: rgb(var(--v-theme-primary));
	transform: translateX(-50%) rotate(45deg);
	border-bottom-right-radius: 2px;
}

.tax-rate-slider :deep(.slider-pin-label__text) {
	width: 100%;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	font-size: 0.88rem;
	font-weight: 700;
	line-height: 1;
}

</style>